import { Prop, Watch } from "vue-property-decorator";
import i18n from "@/i18n";
import Vue from "vue";

export class MonthPickerVue extends Vue {
  @Prop() defValue!: Array<string>;

  @Prop() endYear!: number;

  @Prop() startYear!: number;

  @Prop() isShow!: boolean;

  /** Нижняя граница */
  @Prop() minDate!: string;

  /** Верхняя граница */
  @Prop() maxDate!: string;

  @Watch('minDate', { immediate: true })
  minChanged(val: string) {
    this.$forceUpdate();
  }

  @Watch('maxDate', { immediate: true })
  maxChanged(val: string) {
    this.$forceUpdate();
  }

  defData: any = [];

  get years() {
    const nowYear = new Date().getFullYear();
    const years = [];
    const endYear = this.endYear || nowYear;
    for (let i = +this.startYear; i <= +endYear; i++) {
      years.push(i);
    }
    return years;
  }

  /** Флаг моунта компонента */
  isMounted: boolean = false;

  localeMonths: Array<string> = Object.keys(i18n.t("common.months")).map(
    (item: string) => {
      return i18n.t(`common.months.${item}`).toString();
    }
  );

  /** Память для watcher года в smooth datepicker */
  checkYearChanged: boolean = false;

  @Watch("isShow", { immediate: true })
  showChange(val: any) {
    this.$forceUpdate();
    if (this.$refs.smoothPicker)
      (this.$refs.smoothPicker as Vue & {
        getGroupsRectList: () => void;
      }).getGroupsRectList();
  }

  @Watch("getCurrentIndex", { immediate: true })
  smoothChanged(val: any) {
    if (!this.$refs.smoothPicker) return;
    const minMonth = +this.minDate.substring(5, 7) - 1;
    const maxMonth = +this.maxDate.substring(5, 7) - 1;
    /** Если значение года не поменялось то выходим из метода */
    if (this.checkYearChanged !== val) this.checkYearChanged = val;
    else return;
    /** Ограничение снизу */
    if (val < 1) {
      this.defData[1].list = this.localeMonths.slice(
        minMonth,
        this.localeMonths.length
      );
      if (
        (this.$refs.smoothPicker as Vue & {
          getCurrentIndexList: () => Array<any>;
        }).getCurrentIndexList()[1] >
        this.defData[1].list.length - 1
      ) {
        this.defData[1].currentIndex = this.defData[1].list.length - 1;
        (this.$refs.smoothPicker as Vue & {
          _data: any;
        })._data.currentIndexList[1] = this.defData[1].list.length - 1;
      }
      /** Ограничение сверху */
    } else if (val >= this.defData[0].list.length - 1) {
      this.defData[1].list = this.defData[1].list.slice(0, maxMonth + 1);
      /** Прокручиваем пикер если выбранный элемент за пределами массива */
      if (
        (this.$refs.smoothPicker as Vue & {
          getCurrentIndexList: () => Array<any>;
        }).getCurrentIndexList()[1] >
        this.defData[1].list.length - 1
      ) {
        this.defData[1].currentIndex = this.defData[1].list.length - 1;
        (this.$refs.smoothPicker as Vue & {
          _data: any;
        })._data.currentIndexList[1] = this.defData[1].list.length - 1;
      }
      /** без ограничений */
    } else {
      this.defData[1].list = i18n.t("common.months");
    }
  }

  /** Получение внутреннего индекса datepicker */
  get getCurrentIndex() {
    if (!this.isMounted) {
      return;
    } else if (this.$refs.smoothPicker)
      return (this.$refs.smoothPicker as Vue & {
        getCurrentIndexList: () => Array<any>;
      }).getCurrentIndexList()[0];
    return null;
  }

  /** Получение дефолтного значения пикера */
  getDefValue() {
    let defYear = null;
    let defMonth = new Date().getMonth() + 1;
    if (this.defValue !== undefined && this.defValue[0] !== "") {
      defYear = new Date(this.defValue[0]).getFullYear();
      defMonth = new Date(this.defValue[0]).getMonth() + 1;
    }
    /** Выделяем мин и макс года для обрезания массива */
    let minYear = +this.minDate.substring(0, 4);
    if (!minYear) minYear = 2010;
    const maxYear = +this.maxDate.substring(0, 4);
    /** обрезаем массив */
    this.cutYears(minYear, maxYear);
    this.checkElemInArray(defYear ? defYear : maxYear, this.defData[0].list, 0);
    if (
      this.defData[1].currentIndex === null ||
      this.defData[1].list.length !== 12
    )
      this.checkElemInArray(defMonth, this.defData[1].list, 1);
  }

  /** Обрезаем массив дефолтных данных */
  cutYears(min: any, max: any) {
    this.defData[0].list = this.defData[0].list.slice(
      this.defData[0].list.indexOf(min),
      this.defData[0].list.indexOf(max) + 1
    );
  }

  /** Сбор информации с дата пикера по нажатию кнопки ОК */
  confirm() {
    const ciList = (this.$refs.smoothPicker as Vue & {
      getCurrentIndexList: () => Array<any>;
    }).getCurrentIndexList();
    const year = this.defData[0].list[ciList[0]];
    const mMmonth =
      ciList[1] + 1 > this.defData[1].list.length
        ? this.defData[1].list.length
        : ciList[1] + 1;
    this.defData[1].currentIndex = mMmonth;
    const resMonth =
      this.localeMonths.indexOf(this.defData[1].list[mMmonth - 1]) + 1 > 9
        ? this.localeMonths.indexOf(this.defData[1].list[mMmonth - 1]) + 1
        : "0" +
          (this.localeMonths.indexOf(this.defData[1].list[mMmonth - 1]) + 1);
    const lastDate =
      year +
      "-" +
      resMonth +
      "-" +
      new Date(year, parseInt(resMonth.toString()), 0).getDate();
    this.$emit("changeMonthValue", {
      period: [year + "-" + resMonth + "-01", lastDate]
    });
    this.hidePicker();
  }

  checkElemInArray(elem: any, arr: Array<any>, index: number) {
    if (index === 1) {
      if (
        this.defData[index].currentIndex !==
          this.defData[index].list.indexOf(this.localeMonths[elem - 1]) &&
        this.defData[index].list.indexOf(this.localeMonths[elem - 1]) !== -1 &&
        this.$refs.smoothPicker
      ) {
        this.defData[index].currentIndex = this.defData[index].list.indexOf(
          this.localeMonths[elem - 1]
        );
      } else if (this.defData[index].currentIndex === null)
        this.defData[index].currentIndex = elem - 1;
    }
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i] == elem) { this.defData[index].currentIndex = i; }
    }
    (this.$refs.smoothPicker as Vue & {
      _data: any;
    })._data.currentIndexList[index] = this.defData[index].currentIndex;
  }

  /** Закрытие пикера */
  hidePicker() {
    this.$emit("hidePicker");
  }
}
